module.exports = __webpack_public_path__ + "static/008211-020438ad5b8ef407a9c181c35dd137da.jpg";